import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

const COLORS = ['#0e487a', '#86bddc', '#d16265', '#e9c31a', '#16a34a', '#9333ea', '#f97316', '#06b6d4'];

export default function Tags() {
  const { api } = useAuth();
  const toast = useToast();
  const [items, setItems] = useState([]);
  const [name, setName] = useState('');
  const [color, setColor] = useState(COLORS[0]);
  const [editing, setEditing] = useState(null);

  const load = () => api('/tags').then(setItems).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line

  const save = async () => {
    if (!name.trim()) return;
    try {
      if (editing) await api(`/tags/${editing.id}`, { method: 'PUT', body: JSON.stringify({ name, color }) });
      else         await api('/tags',                { method: 'POST', body: JSON.stringify({ name, color }) });
      setName(''); setEditing(null); load();
      toast.success('تم الحفظ');
    } catch (e) { toast.error(e.message); }
  };

  const remove = async (id) => {
    if (!window.confirm('حذف هذا الوسم؟')) return;
    try { await api(`/tags/${id}`, { method: 'DELETE' }); load(); toast.success('تم الحذف'); }
    catch (e) { toast.error(e.message); }
  };

  return (
    <div>
      <h2 style={{ marginBottom: 20 }}>🏷️ الوسوم</h2>
      <div className="card" style={{ marginBottom: 20 }}>
        <div className="card-title">{editing ? 'تعديل وسم' : 'وسم جديد'}</div>
        <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
          <input className="form-input" placeholder="اسم الوسم" value={name} onChange={e => setName(e.target.value)} style={{ flex: 1, minWidth: 200 }}/>
          <div style={{ display: 'flex', gap: 4 }}>
            {COLORS.map(c => (
              <button key={c} onClick={() => setColor(c)} style={{ width: 28, height: 28, borderRadius: '50%', border: color === c ? '3px solid var(--text)' : '1px solid var(--border)', background: c, cursor: 'pointer' }} type="button" aria-label={c}/>
            ))}
          </div>
          <button className="btn btn-primary" onClick={save}>{editing ? 'حفظ' : 'إضافة'}</button>
          {editing && <button className="btn btn-outline" onClick={() => { setEditing(null); setName(''); }}>إلغاء</button>}
        </div>
      </div>
      <div className="card">
        <div className="card-title" style={{ marginBottom: 12 }}>{items.length} وسم</div>
        {items.length === 0 ? <div className="empty">لا وسوم بعد</div> : (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {items.map(t => (
              <div key={t.id} style={{ padding: '6px 12px', borderRadius: 16, background: t.color || 'var(--gray-100)', color: '#fff', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                <span>#{t.name}</span>
                <span style={{ fontSize: 11, opacity: .8 }}>({t.transcriptions_count || 0})</span>
                <button onClick={() => { setEditing(t); setName(t.name); setColor(t.color || COLORS[0]); }} style={{ background: 'transparent', border: 'none', color: '#fff', cursor: 'pointer' }}>✏️</button>
                <button onClick={() => remove(t.id)} style={{ background: 'transparent', border: 'none', color: '#fff', cursor: 'pointer' }}>🗑️</button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
